import * as React from 'react';
import type { OracleCategoryDetail } from '../../services/geminiService';
import { SectionHeader } from './MemoPrimitives';
import { coerceToText } from '../../lib/utils';

export const OracleDetailSection = ({ title, icon: Icon, data }: { title: string, icon: any, data: OracleCategoryDetail }) => (
  <div className="pdf-section oi-card mb-10 p-7">
    <SectionHeader icon={Icon} title={title} className="mb-8" />
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="space-y-6">
        <div>
          <div className="text-[10px] font-medium uppercase tracking-widest text-ink-500 mb-2">Type / Assessment</div>
          <div className="text-xl font-serif font-medium italic text-ink">{coerceToText(data.type)}</div>
        </div>
        <div>
          <div className="text-[10px] font-medium uppercase tracking-widest text-ink-500 mb-2">Strength & Duration / Assessment</div>
          <div className="text-lg text-ink-600">{coerceToText(data.strength)} ({coerceToText(data.duration)})</div>
        </div>
        <p className="text-base text-ink-600 leading-relaxed">
          {coerceToText(data.description)}
        </p>
      </div>
      <div className="space-y-6 p-6 bg-danger-50 rounded-md border border-danger-100">
        <div>
          <div className="text-[10px] font-medium uppercase tracking-widest text-danger-600 mb-2">Vulnerabilities</div>
          <p className="text-sm text-danger-700 leading-relaxed">{coerceToText(data.vulnerabilities)}</p>
        </div>
        <div>
          <div className="text-[10px] font-medium uppercase tracking-widest text-danger-600 mb-2">Competitive Threats</div>
          <p className="text-sm text-danger-700 leading-relaxed">{coerceToText(data.competitiveThreats)}</p>
        </div>
      </div>
    </div>
  </div>
);
